import * as THREE from 'three'
import { useLoader } from '@react-three/fiber'
import React, { useEffect, useState, useRef } from 'react'
import { Box } from '@react-three/drei'
import materialtextures from './config/material.json'
import Material from './Materials'

const commandpanelsize = 15;

function PanelTop(params) {
  return (
    <mesh 
      receiveShadow 
      castShadow 
      position={[0, 3*params.dim[2]/4+4/*+commandpanelsize/2*/, 0]}
      item='backTop' 
    >
      <Material {...params} />
      <boxGeometry args={[2, params.dim[2]/2/*-commandpanelsize*/, params.dim[0]]}/>
    </mesh>
  )
}

function CommandPanel(params) {
  const sideoffs = 5;
  const offs = params.dim[2]/28;
  let offset_alarm = params.monitor?0:-params.dim[2]/12+sideoffs;
  let offsets = [offs+sideoffs, 0+sideoffs, -offs+sideoffs];
  const buttoncolor = 'navy';
  return (
    <group>
      <mesh 
        receiveShadow 
        castShadow 
        position={[0.5, 2*params.dim[2]/4+4+commandpanelsize/2, 0]}
        item='backTop' >
        <Material {...params} />
        <boxGeometry args={[2, commandpanelsize, params.dim[0]/2]}/>
      </mesh>
      <mesh receiveShadow castShadow position={[2, 2*params.dim[2]/4+4+commandpanelsize/2, offset_alarm]} rotation-z={-Math.PI / 2} >
        <cylinderBufferGeometry attach="geometry" args={[2.5, 2.5, 2.5, 32]} />
        <Material texture='maroon' material='glass' type='color' />
      </mesh>
      {!params.monitor?
      <group >
        <mesh receiveShadow castShadow position={[2, 2*params.dim[2]/4+4+commandpanelsize/2, offsets[0]]} rotation-z={-Math.PI / 2} >
          <cylinderBufferGeometry attach="geometry" args={[2, 2, 2, 32]} />
          <Material texture={buttoncolor} material='glass' type='color' />
        </mesh>
        <mesh receiveShadow castShadow position={[2, 2*params.dim[2]/4+4+commandpanelsize/2, offsets[1]]} rotation-z={-Math.PI / 2} >
          <cylinderBufferGeometry attach="geometry" args={[2, 2, 2, 32]} />
          <Material texture={buttoncolor} material='glass' type='color' />
        </mesh>
        <mesh receiveShadow castShadow position={[2, 2*params.dim[2]/4+4+commandpanelsize/2, offsets[2]]} rotation-z={-Math.PI / 2} >
          <cylinderBufferGeometry attach="geometry" args={[2, 2, 2, 32]} />
          <Material texture={buttoncolor} material='glass' type='color' />
        </mesh>
      </group>: null}
    </group>

  )
}

function PanelBottom(params) {
  return (
    <mesh 
      receiveShadow 
      castShadow 
      position={[0, params.dim[2]/4+4, 0]}
      item='backBottom' 
    >
      <Material {...params} />
      <boxGeometry args={[2, params.dim[2]/2, params.dim[0]]}/>
    </mesh>
  )
}

function Carpet(params) {

  return (
    <Box 
      receiveShadow 
      castShadow 
      smoothness={10} 
      radius={0.0} 
      item='carpet'
      rotation-x={-Math.PI / 2} 
      position={[params.dim[1]/2-1, 2, 0]} 
      scale={[params.dim[1], params.dim[0], 4]} >
      <Material {...params} />
    </Box>
  )
}

function Screen(params) {
  const elev = 150
  const material = useRef()
  const screencontent = useLoader(THREE.TextureLoader, `${process.env.PUBLIC_URL}/img/screen-1.png`); 
  return (
    <group>
      <mesh 
        position={[1.1,elev,0]}
        item='screen' 
      >
          <meshPhysicalMaterial
            ref={material}
            clearcoat={0}
            clearcoatRoughness={1}
            transmission={0.4}
            roughness={0}
            envMapIntensity={2}
            metalness={0.4}
            map={screencontent}    
          />
          <boxGeometry args={[4, 45, 75]}/>
      </mesh>
      <mesh 
        position={[-1,elev,0]}
        item='screen-bevel' 
      >
        <meshPhysicalMaterial
          roughness={1}
          envMapIntensity={2}
          metalness={0}
          color='black'
        />
            <boxGeometry args={[8, 45.5, 75.5]}/>
      </mesh>
    </group>
  )
}


export default function Cabin(props) {
 
  const [hovered, setHovered] = useState(null)

  useEffect(() => {
    document.body.style.cursor = hovered ? 'pointer' : 'default'
  }, [hovered])
  
  
  return (
      <group 
        position={props.position}
        dispose={null}
        onPointerOver={ e=>{e.stopPropagation(); setHovered(e.object.item)}}
        onPointerOut={ e=>{e.stopPropagation(); setHovered(null)}}>

            <Carpet 
              texture={materialtextures[props.carpet.material][props.carpet.texture]} 
              material={props.carpet.material} 
              type={props.carpet.type} 
              dim={props.dim} />
              
            <PanelTop 
              texture={materialtextures[props.backTop.material][props.backTop.texture]} 
              material={props.backTop.material} 
              type={props.backTop.type} 
              dim={props.dim}/>

            <CommandPanel
              texture={materialtextures[props.commands.material][props.commands.texture]} 
              material={props.commands.material} 
              type={props.commands.type} 
              dim={props.dim}
              monitor={props.monitor}
            />


            <PanelBottom 
              texture={materialtextures[props.backBottom.material][props.backBottom.texture]} 
              material={props.backBottom.material} 
              type={props.backBottom.type} 
              dim={props.dim}/>

            {props.monitor?<Screen />:null}

      </group>    
  )
}
